export const base_url =
  `/serviceinventory_svc/pb`;

export const services_base_url =   `${process.env.REACT_APP_BASE_URL_EXPERT}/serviceinventory_svc/pb`;



